import React, { useEffect, useRef } from 'react';
import { Link } from 'react-scroll';

export default function Nav({ onMenuToggle = () => {} }) {
  const node = useRef();

  const handleClick = e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    if(document.getElementsByClassName('is-menu-visible').length > 0) {
      onMenuToggle();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  });
  return (
    <nav id="menu">
      <div className="inner" ref={node}>
        <h2>
          <Link
            onClick={e => {
              onMenuToggle();
            }}
            to="page-wrapper"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="anchor"
          >
            Home
          </Link>
        </h2>
        <ul className="links">
          <li>
            <Link
              onClick={e => {
                onMenuToggle();
              }}
              to="about"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="anchor"
            >
              About
            </Link>
          </li>
          <li>
            <Link
              onClick={e => {
                onMenuToggle();
              }}
              to="projects"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="anchor"
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              onClick={e => {
                onMenuToggle();
              }}
              to="blog"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="anchor"
            >
              Blog
            </Link>
          </li>
          <li>
            <Link
              onClick={e => {
                onMenuToggle();
              }}
              to="contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="anchor"
            >
              Contact
            </Link>
          </li>
        </ul>
        <a
          className="close"
          onClick={e => {
            e.preventDefault();
            onMenuToggle();
          }}
          href="#menu"
        >
          {''}
        </a>
      </div>
    </nav>
  );
}
